// ABOUTME: Thin indeterminate progress bar — slim slider that travels left→right
// ABOUTME: in a loop. Used to signal "background work is happening" without
// ABOUTME: blocking the UI; matches the @keyframes loading-bar in index.css.

import * as React from "react"
import { cn } from "@shared/lib/utils"

interface CIndeterminateBarProps {
  loading?: boolean
  /** Extra classes for the wrapper — typically used to override `top-*` */
  className?: string
}

export const CIndeterminateBar: React.FC<CIndeterminateBarProps> = ({ loading, className }) => {
  if (!loading) return null

  return (
    <div className={cn("absolute top-0 left-0 right-0 h-0.5 overflow-hidden z-30 pointer-events-none", className)}>
      {/* Accent blue, like every other primary signal — `blue-400` is reserved for
          the datepicker, zone 1 and in-chart links (docs/DESIGN_SYSTEM.md §1). */}
      <div className="h-full w-1/3 bg-primary animate-[loading-bar_1.2s_ease-in-out_infinite]" />
    </div>
  )
}
